export const CURRENT_PTWAVE_VERSION = 'v2.1.3';
export const PAPER_PTWAVE_VERSION = 'v1.0';
